// extracted by mini-css-extract-plugin
export var buttonClean = "PaginatedCollection-module--buttonClean--3Eu-W";
export var entriesGroup = "PaginatedCollection-module--entriesGroup--3wuKN";
export var pagination = "PaginatedCollection-module--pagination--23CXo";
export var active = "PaginatedCollection-module--active--l7MT_";
export var prevBtnRotate = "PaginatedCollection-module--prevBtnRotate--1wFbZ";
export var icon = "PaginatedCollection-module--icon--1sHPT";